export const voidSizes = {
    _36MM_STANDARD: {
        label: "36mm Standard",
        key: "_36MM_STANDARD"
    },
    _56_PIPE_VOID : {
        label: "56mm Pipe Void",
        key: "_56_PIPE_VOID"
    }
} as const;